import { Box } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const ReportChart = ({ chartData, extensionTypes, appliedFilters, filters }) => {
  // Generate colors for chart lines
  const getLineColors = () => {
    const colors = [
      '#1b1c1b', // Neutral Primary
      '#6e4c01', // Yellow 35
      '#367c2b', // Theme Green
      '#78ab68', // Green 65
      '#ad7a03', // Yellow 55
      '#dda002', // Yellow 75
      '#ffde00', // Theme Yellow
      '#f2e1bd', // Sand
      '#e7e3d4'  // Tan
    ];
    return colors;
  };

  return (
    <Box sx={{ width: '100%', height: 400, p: 2 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis 
            allowDecimals={false}
            tickFormatter={(value) => {
              if ((appliedFilters && appliedFilters.volume === 'value') || (!appliedFilters && filters.volume === 'value')) {
                return new Intl.NumberFormat('en-US', {
                  notation: 'compact',
                  maximumFractionDigits: 1
                }).format(value);
              }
              return value;
            }}
          />
          <Tooltip 
            formatter={(value, name) => {
              if ((appliedFilters && appliedFilters.volume === 'value') || (!appliedFilters && filters.volume === 'value')) {
                return [
                  new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(value),
                  name
                ];
              }
              return [value, name];
            }}
            labelFormatter={(label) => `Month: ${label}`}
          />
          <Legend />
          {extensionTypes.map((extensionType, index) => (
            <Line
              key={extensionType}
              type="monotone"
              dataKey={extensionType}
              stroke={getLineColors()[index % getLineColors().length]}
              strokeWidth={2}
              dot={{ r: 4 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default ReportChart;
